<template>
    <div>
        <ob-modal2 :show.sync="show" :type="1" :width="300">
            <div class="modal-content">
                    <div class="CompatHeader header-border-0">
                            <div class="overlay-header profileview-overlay">
                                <button data-dismiss="modal" type="button" @click="cancel">
                                    <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/Close_icon-01.svg`" class="close_popup">
                                </button>
                                <h3 style="margin-top:5px;">Profile Information</h3>
                            </div>
                            <div v-if="sizeError" class="cropit-image-preview-container">
                                <div class="cropit-image-preview has-error">
                                     <div class="error-msg has-error">Please use an image that's at least 300px in width and 300px in height.</div>
                                </div>
                            </div>
                    </div>

                    <div id="profilePopUpBody">
                            <div class="default-profile-image">
                                <img class="default-image croppit_profile_dp" id="baseimg" :src="profileLink == null || profileLink == '' ? `${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/crop_image/default-avatar.png` : profileLink" alt="logo"  width="85" />
                            </div>
                            <div class="profile-name">
                                <p class="profile-name-edit first-name">{{loggedInUserObj.name}}</p>
                                <p class="profile-comapny-name">{{loggedInUserObj.email}}</p>
                                <p class="profile-comapny-name">{{loggedInUserObj.designation}}</p>
                            </div>
                           <template v-if="profileLink">
                                <div class="update-photo-div" style="display: block;">
                                    <input id="file" class="cropit-image-input" type="file" accept="image/*" @change="uploadLogo()" style="display:none;" />
                                    <a @click="triggerInput()" class="update-photo-text EditProPic"><span v-tooltip="'Please upload your picture with minimum size of 300x300 Pixels.Thank you'" class="add-icon"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/crop_image/photo.svg`" class="image-update-icon">Change</span></a>
                                    <p  @click="removeProfile" class="remove-photo-text remove-profile-pic-js"><span class="add-icon"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/crop_image/delete.svg`" class="image-remove-icon">Remove</span></p>
                                </div>
                            </template>
                            <template v-else>
                                <div class="add-photo-div">
                                    <input id="file" class="cropit-image-input" type="file" accept="image/*" @change="uploadLogo()" style="display:none;" />
                                    <a @click="triggerInput()" class="add-photo-text EditProPic"><span v-tooltip="'Please upload your picture with minimum size of 300x300 Pixels.Thank you'" class="add-icon"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/crop_image/photo.svg`" class="image-add-icon">Add</span></a>
                                </div>
                            </template>
                        </div>

                    <div>
                </div>
            </div>
        </ob-modal2>
        <ob-modal2 :show.sync="showCrop" :type="1" :width="400">
             <div class="modal-content" id="crop">
                    <img @click="cancel_crop" class="crop_close" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/crop_image/Close_icon.svg`">
                    <h4 class="crop_heading">Crop Image</h4>
                    <!-- <div class="cut_crop">
                       <cropit></cropit>
                    </div>  -->

                   <div class="cut_crop">
                        <div class="cropit-preview">
                            <img class="cropit-preview-image" alt="logo" id="logoImg" style="transform-origin: left top 0px; will-change: transform; transform: translate(0px, 0px) scale(0.75) rotate(0deg);"/>
                        </div>
                    </div>
                     <!-- <div class="image-size-label">
                        <img class="crop_zoom-out" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/crop_image/Image_icon.svg`">
                        <span><input type="range" class="cropit-image-zoom-input"></span>
                         <input type="hidden" name="image-data" class="hidden-image-data" />
                        <img class="crop_zoom-in" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/crop_image/Image_icon.svg`">
                    </div>   -->
                    <div class="bottom_save">
                        <button class="cover_submit cover-img_cancel" @click="cancel_crop">Cancel</button> <button class="cover_submit ob_cover-img_save" @click="saveProfile">Save</button>
                    </div>
            </div>

        </ob-modal2>
    </div>
</template>
<script>
 export default {
    props:["openModal", "orgId"],
    data() {
        return{
                show:false,
                profilePic:false,
                showCrop:false,
                logoInfo:'',
                OrgInfo:'',
                sizeError:false,
                empData:''
        }
    },
    created(){
       //this.getProfile()
    },
    watch: {
        openModal(val) {
            this.show = val;
            if(val){
             this.getProfile()
            }
           //console.log(this.show,"show")
        },
         show(val) {
            this.$emit('update:openModal', val)
        }

    },
    computed:{
        profileLink(){
            if(this.empData.ProfilePicLink == '' || this.empData.ProfilePicLink == null){
                 return null
            }
            else{
                return this.empData.ProfilePicLink
            }
        },
    },
    methods: {
        getProfile(){
            ajax.get(`/Employee/${loggedInUserObj.empId}/BasicInfo`, {}, (res) => {
                    if(res.data.State == true){
                            this.empData = res.data.Employee
                    }else{
                        this.ESSEnableDisable(res)
                        //this.leftLoader = false
                    }

             })
        },
        cancel(){
            this.show = false
        },
        cancel_crop(){
            this.show = true
            this.showCrop=false
            document.getElementById('file').value="";
        },
        triggerInput() {
            document.getElementById('file').click()
        },
        uploadLogo(){
            var fi = document.getElementById('file');
            var upload=false;
            var error=false;
            if (fi.files.length > 0) {
                var that=this;
              // FIRST CHECK IF ANY FILE IS SELECTED.
                var reader = new FileReader(); // CREATE AN NEW INSTANCE.
                reader.onload = function (e) {

                    var img = new Image();
                    img.src = e.target.result;
                    img.onload = function () {
                        var w = this.width;
                        var h = this.height;
                        if(w > 300 && h > 300){
                          var data = new FormData();
                          data.append('uploadFile', document.getElementById('file').files[0]);
                          //var img = document.getElementsByClassName("cropit-preview-image")
                          //img[0].src = e.target.result;
                          //img[0].className ="cropit-preview-background"
                          var img = document.getElementById("logoImg");
                          img.src = e.target.result;
                          that.show = false
                          that.showCrop= true
                        }
                        else{
                            that.sizeError = true
                            setTimeout(() => {
                                that.sizeError = false
                            }, 5e3);
                        }
                    }

                };
                reader.readAsDataURL(fi.files.item(0));
            }
        },
        removeProfile(){
           document.getElementById('file').value="";
           this.$loading({ 'loadingText': 'Loading...' })
            ajax.put(`RemoveEmployeeProfilePic?orgId=${loggedInUserObj.orgId}`,{}, (res) => {
                if(res.data.State == true){
                     this.getProfile()
                     events.fire('profileRemoved')
                     this.$loading({}).close()
                        this.$message({
                            type: 'success',
                            message: 'Profile pic removed successfully'
                        })
                       // this.getOrgInfo()
                }
                else{
                    this.$loading({}).close()
                    this.ESSEnableDisable(res)
                    this.$message({
                        type: "error",
                        message: "Error in Removed Profile Pic"
                    });
                }
            })

        },
        saveProfile(){
            var data = new FormData();
            data.append('uploadFile', document.getElementById('file').files[0]);
              var input = document.getElementById("file");
                var fReader = new FileReader();
                fReader.readAsDataURL(input.files[0]);
                fReader.onloadend = function(e){
                   var img = document.getElementById("logoImg");
                   img.src = e.target.result;
                }
            this.$loading({ 'loadingText': 'Loading...' })
            ajax.put(`UpdateEmployeeProfilePic?orgId=${loggedInUserObj.orgId}`,data, (res) => {
                 if(res.data.State == true){
                        this.getProfile()
                        events.fire('profileUpdate')
                        this.$loading({}).close()
                        this.$message({
                            type: 'success',
                            message: 'Profile pic updated successfully'
                        })
                }
                else{
                    this.$loading({}).close()
                    this.ESSEnableDisable(res)
                    this.$message({
                        type: "error",
                        message: "Error in Profile Upload"
                    });
                }

            })
            this.show = true
            this.showCrop=false
        }

    }
 }
</script>
<style lang="scss" scoped>
#baseimg{
  height:275px;
}
.image-upload > input
{
    display: none;
}

.image-update-icon {
    width: 34px;
    padding-right: 10px;
    -webkit-transform: translateY(-3px);
    transform: translateY(-3px);
}
.modal-content{
    height: 500px;
}
#profilePopUpBody{
  height: 300px;
}
.crop_heading{
 padding-top: 12px;
}
#crop{
    height: 540px;
}
.cropit-preview{
    height: 302px;
    width: 302px;
}
#logoImg{
    height: 400px;
    width: 400px;
    border-radius: 3px;
}
.bottom_save{
    top: 440px;
}
.profile-name-edit.first-name{
    margin-left:0;
}
// .cropit-preview{
// display: none;
// }


</style>




// WEBPACK FOOTER //
// src/components/ESSProfile/ESSSettings/ProfilePicModal.vue